import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogHeaderComponent, DialogService } from '@mode/shared/ui';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AutofocusDirective, ButtonComponent } from '@mode/capra';
import {
  AbstractControl,
  FormGroup,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { validNameValidator } from '@mode/dataset/ui';
import { DataViewFacade } from '@mode/switch-views/contract';

const duplicateValidator =
  (keys: string[]): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null =>
    keys.includes(control.value?.trim()) ? { invalidNameKey: true } : null;
@Component({
  standalone: true,
  imports: [
    AutofocusDirective,
    CommonModule,
    DialogHeaderComponent,
    DragDropModule,
    ButtonComponent,
    ReactiveFormsModule,
  ],
  selector: 'mode-rename-dataset-modal',
  templateUrl: './rename-dataset-modal.component.html',
  styleUrls: ['./rename-dataset-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenameDatasetModalComponent implements OnInit {
  form: FormGroup;
  existedNames: string[] = [];
  get datasetName() {
    return this.form.get('datasetName');
  }

  constructor(
    private fb: NonNullableFormBuilder,
    private dialogService: DialogService,
    private dataViewFacade: DataViewFacade,
    @Inject(MAT_LEGACY_DIALOG_DATA)
    private data: {
      queryName: string;
      onSubmit: (name: string) => void;
    }
  ) {
    this.form = this.fb.group({
      datasetName: [this.data.queryName, [Validators.required, validNameValidator]],
    });
  }

  ngOnInit(): void {
    this.dataViewFacade.enhancedDatasetResults$.subscribe((results) => {
      this.existedNames = results.map((dataset) => dataset.displayName);
      this.updateValidators();
    });
  }

  handleSubmit(): void {
    if (this.datasetName) {
      this.datasetName.setValue(this.datasetName.value?.trim(), { emitEvent: false });
    }
    if (this.form.valid) {
      const { datasetName } = this.form.value;
      const { onSubmit } = this.data;
      this.dialogService.closeAll();
      onSubmit(datasetName);
    }
  }
  close(): void {
    this.dialogService.closeAll();
  }

  private updateValidators(): void {
    const datasetNameControl = this.datasetName;
    datasetNameControl?.setValidators([Validators.required, validNameValidator, duplicateValidator(this.existedNames)]);
    datasetNameControl?.updateValueAndValidity();
  }
}
